import { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { Box, CircularProgress, Container, Typography } from "@mui/material";
import {
  useGenerateChatBotUrlQuery,
  useGetUserQuery,
} from "features/auth/auth";
import { useAppSelector } from "features/store";

export default function ChatPage() {
  const [iframeUrl, setIframeUrl] = useState(null);
  const webAccessDenied = useAppSelector((state) => state.auth.webAccessDenied);
  const { isLoading: userLoading, error: userError } = useGetUserQuery(
    undefined,
    { skip: !!webAccessDenied },
  );
  const { data, error, isLoading, refetch, isFetching } =
    useGenerateChatBotUrlQuery(undefined, {
      refetchOnMountOrArgChange: false,
    });

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (data && data.url) {
      setIframeUrl(data.url);
    }
  }, [data]);

  if (userLoading || isLoading || isFetching) {
    return (
      <Layout title="AI Agent" content="AI Agent" noScroll={true}>
        <Container
          component="main"
          maxWidth="sm"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Container>
      </Layout>
    );
  }

  if (userError) {
    return (
      <Layout title="AI Agent" content="AI Agent">
        <Box pt={2}>
          <Typography variant="h6" color="error">
            Error when receiving user data
          </Typography>
        </Box>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout title="AI Agent" content="AI Agent">
        <Box pt={2}>
          <Typography variant="h6" color="error">
            Error when getting the URL for the ChatBot
          </Typography>
        </Box>
      </Layout>
    );
  }

  return (
    <Layout title="AI Agent" content="AI Agent" noScroll={true}>
      <Container
        component="main"
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          height: "calc(100vh - 188px)",
          px: { xs: 1, sm: 2 },
        }}
      >
        {iframeUrl ? (
          <Box
            sx={{
              width: { xs: "100%", sm: "80%", md: "60%" },
              height: "calc(100vh - 200px)",
              alignSelf: "center",
              minHeight: 300,
            }}
          >
            <iframe
              title="AI Agent"
              style={{
                width: "100%",
                height: "100%",
                border: 0,
              }}
              src={iframeUrl}
              allow="autoplay; fullscreen"
            />
          </Box>
        ) : (
          <CircularProgress />
        )}
      </Container>
    </Layout>
  );
}
